"use client";

import React, { useState } from "react";
import { toast } from "react-toastify";

const REASONS = [
    { value: "defect", label: "Produs defect" },
    { value: "not_as_described", label: "Nu corespunde descrierii" },
    { value: "wrong_item", label: "Produs greșit livrat" },
    { value: "damaged", label: "Deteriorat la livrare" },
    { value: "changed_mind", label: "Schimbare de părere" },
    { value: "other", label: "Alt motiv" },
];

const RETURN_METHODS = [
    { value: "curier", label: "Trimitere prin curier (pe cheltuiala mea)" },
    { value: "ridicare", label: "Ridicare de la adresă (vom programa un curier)" },
    { value: "personal", label: "Predare personală la sediu" },
];

const REFUND_METHODS = [
    { value: "cont", label: "Rambursare în cont bancar (IBAN)" },
    { value: "voucher", label: "Voucher de reducere" },
];

export default function FormularRetur() {
    const [form, setForm] = useState({
        orderID: "",
        name: "",
        email: "",
        phone: "",
        reason: "",
        details: "",
        returnMethod: "",
        refundMethod: "",
        iban: "",
        accountName: "",
    });
    const [agreePrivacy, setAgreePrivacy] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    function handleChange(e) {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    }

    async function handleSubmit(e) {
        e.preventDefault();

        if (!agreePrivacy || !agreeTerms) {
            toast.error("Trebuie să accepți politica de confidențialitate și termenii și condițiile.");
            return;
        }

        setLoading(true);
        try {
            const res = await fetch("/api/returns/create", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });
            const data = await res.json();
            if (!res.ok) {
                toast.error(data.error || "A apărut o eroare.");
            } else {
                setSubmitted(true);
            }
        } catch {
            toast.error("Eroare de rețea. Încearcă din nou.");
        } finally {
            setLoading(false);
        }
    }

    if (submitted) {
        return (
            <div style={styles.container}>
                <div style={{ textAlign: "center", padding: "2rem 0" }}>
                    <div style={{ fontSize: 56, marginBottom: 16 }}>✓</div>
                    <h2 style={{ fontWeight: 700, fontSize: 24, marginBottom: 12 }}>Cerere trimisă cu succes!</h2>
                    <p style={{ color: "#555", fontSize: 15, lineHeight: 1.6 }}>
                        Cererea ta de retur pentru comanda <strong>#{form.orderID}</strong> a fost înregistrată.<br />
                        Vei fi contactat în maxim 2-3 zile lucrătoare pe adresa <strong>{form.email}</strong>.
                    </p>
                    <a href="/" style={{ display: "inline-block", marginTop: 24, padding: "12px 28px", background: "#000", color: "#fff", borderRadius: 8, textDecoration: "none", fontWeight: 600 }}>
                        Înapoi la magazin
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h1 style={styles.title}>Formular de Retur</h1>
                <p style={styles.subtitle}>
                    Completați formularul pentru a solicita returul produselor. Veți fi contactat în 2-3 zile lucrătoare.
                </p>
            </div>

            <div style={styles.infoBox}>
                <strong>Informație importantă:</strong> Retururile sunt acceptate în termen de 14 zile calendaristice de la primirea coletului.
                Asigurați-vă că aveți la îndemână numărul comenzii din email-ul de confirmare.
            </div>

            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                {/* Detalii comandă */}
                <div style={styles.section}>
                    <h3 style={styles.sectionTitle}>Detalii Comandă</h3>
                    <div style={styles.row}>
                        <Field label="Numărul comenzii *">
                            <input name="orderID" style={styles.input} placeholder="Ex: 1234" value={form.orderID} onChange={handleChange} required />
                        </Field>
                    </div>
                </div>

                {/* Date personale */}
                <div style={styles.section}>
                    <h3 style={styles.sectionTitle}>Date Personale</h3>
                    <div style={styles.row}>
                        <Field label="Nume complet *">
                            <input name="name" style={styles.input} placeholder="Ion Popescu" value={form.name} onChange={handleChange} required />
                        </Field>
                        <Field label="Email *">
                            <input name="email" type="email" style={styles.input} placeholder="email@exemplu.ro" value={form.email} onChange={handleChange} required />
                        </Field>
                    </div>
                    <div style={styles.row}>
                        <Field label="Telefon *">
                            <input name="phone" type="tel" style={styles.input} placeholder="07XX XXX XXX" value={form.phone} onChange={handleChange} required />
                        </Field>
                    </div>
                </div>

                {/* Motivul returului */}
                <div style={styles.section}>
                    <h3 style={styles.sectionTitle}>Motivul Returului</h3>
                    <Field label="Motivul *">
                        <select name="reason" style={styles.input} value={form.reason} onChange={handleChange} required>
                            <option value="">-- Selectează motivul --</option>
                            {REASONS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                        </select>
                    </Field>
                    <Field label="Detalii suplimentare">
                        <textarea name="details" style={{ ...styles.input, minHeight: 90, resize: "vertical" }}
                            placeholder="Descrieți pe scurt problema sau motivul returului..."
                            value={form.details} onChange={handleChange} />
                    </Field>
                </div>

                {/* Metoda de returnare */}
                <div style={styles.section}>
                    <h3 style={styles.sectionTitle}>Metoda de Returnare</h3>
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        {RETURN_METHODS.map(m => (
                            <label key={m.value} style={styles.radioLabel}>
                                <input type="radio" name="returnMethod" value={m.value} checked={form.returnMethod === m.value} onChange={handleChange} required />
                                <span>{m.label}</span>
                            </label>
                        ))}
                    </div>
                </div>

                {/* Metoda de rambursare */}
                <div style={styles.section}>
                    <h3 style={styles.sectionTitle}>Metoda de Rambursare</h3>
                    <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
                        {REFUND_METHODS.map(m => (
                            <label key={m.value} style={styles.radioLabel}>
                                <input type="radio" name="refundMethod" value={m.value} checked={form.refundMethod === m.value} onChange={handleChange} required />
                                <span>{m.label}</span>
                            </label>
                        ))}
                    </div>

                    {form.refundMethod === "cont" && (
                        <div style={{ display: "flex", flexDirection: "column", gap: 14, padding: "16px", background: "#fffbeb", borderRadius: 8, border: "1px solid #fde68a" }}>
                            <Field label="IBAN *">
                                <input name="iban" style={styles.input} placeholder="RO49AAAA1B31007593840000" value={form.iban} onChange={handleChange} required={form.refundMethod === "cont"} />
                            </Field>
                            <Field label="Titular cont *">
                                <input name="accountName" style={styles.input} placeholder="Numele titular cont" value={form.accountName} onChange={handleChange} required={form.refundMethod === "cont"} />
                            </Field>
                        </div>
                    )}
                </div>

                {/* Checkboxuri */}
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    <label style={styles.checkLabel}>
                        <input type="checkbox" checked={agreePrivacy} onChange={() => setAgreePrivacy(p => !p)} />
                        <span>Sunt de acord cu <a href="/politica-de-confidentialitate" style={styles.link}>Politica de Confidențialitate</a></span>
                    </label>
                    <label style={styles.checkLabel}>
                        <input type="checkbox" checked={agreeTerms} onChange={() => setAgreeTerms(p => !p)} />
                        <span>Sunt de acord cu <a href="/termeni-si-conditii" style={styles.link}>Termenii și Condițiile</a></span>
                    </label>
                </div>

                <div style={{ display: "flex", gap: 12 }}>
                    <button type="submit" disabled={loading} style={styles.btnPrimary}>
                        {loading ? "Se trimite..." : "Trimite cererea de retur"}
                    </button>
                    <button type="reset" onClick={() => setForm({ orderID: "", name: "", email: "", phone: "", reason: "", details: "", returnMethod: "", refundMethod: "", iban: "", accountName: "" })} style={styles.btnSecondary}>
                        Resetează
                    </button>
                </div>
            </form>
        </div>
    );
}

function Field({ label, children }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>{label}</label>
            {children}
        </div>
    );
}

const styles = {
    container: { maxWidth: 760, margin: "60px auto", padding: "0 16px 60px" },
    header: { marginBottom: 28, paddingBottom: 20, borderBottom: "1px solid #e5e5e5" },
    title: { fontSize: 28, fontWeight: 700, marginBottom: 8 },
    subtitle: { fontSize: 15, color: "#555", lineHeight: 1.6 },
    infoBox: { background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 10, padding: "14px 18px", fontSize: 14, color: "#0c4a6e", lineHeight: 1.6, marginBottom: 24 },
    section: { background: "#fafafa", border: "1px solid #e5e5e5", borderRadius: 10, padding: "20px 20px 16px" },
    sectionTitle: { fontSize: 15, fontWeight: 700, marginBottom: 16, color: "#111" },
    row: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 },
    input: { background: "#fff", border: "2px solid #e5e5e5", borderRadius: 8, padding: "11px 14px", fontSize: 14, color: "#111", width: "100%", fontFamily: "inherit", boxSizing: "border-box", transition: "border-color 0.2s" },
    radioLabel: { display: "flex", alignItems: "center", gap: 10, cursor: "pointer", fontSize: 14 },
    checkLabel: { display: "flex", alignItems: "center", gap: 10, cursor: "pointer", fontSize: 14 },
    link: { color: "#2563eb", textDecoration: "underline" },
    btnPrimary: { background: "#000", color: "#fff", border: "none", borderRadius: 8, padding: "13px 28px", fontSize: 15, fontWeight: 600, cursor: "pointer" },
    btnSecondary: { background: "transparent", color: "#555", border: "2px solid #d0d0d0", borderRadius: 8, padding: "13px 28px", fontSize: 15, fontWeight: 600, cursor: "pointer" },
};
